import { createConnectQueryKey, useMutation } from '@connectrpc/connect-query'
import { listContractors } from '@ebalance/proto/bffuser/v1/contractor_service-ContractorService_connectquery'
import { importCustomerContracts } from '@ebalance/proto/bffuser/v1/customer_contract_csv_service-CustomerContractCsvService_connectquery'
import {
  getContractTrend,
  getCustomerSupplyPointFormOptions,
  listCustomerSupplyPoints,
  listCustomers,
} from '@ebalance/proto/bffuser/v1/customer_service-CustomerService_connectquery'
import { useQueryClient } from '@tanstack/react-query'

import { type InvalidatingMutationResultFor } from '~/hooks/useInvalidatingMutation'

/**
 * 顧客契約 CSV 取込 mutation フック (プレビュー / 確定共通、dry_run で分岐。`useImportCisContracts` と同判断)。
 *
 * 本画面 (`pages/CustomerContractCsvUpload`) からのみ使う page-local hook。確定 (applied) で地点・需要家・契約者・
 * 契約電力の期間が増減するため、顧客管理の一覧・選択肢・契約推移の日別集計 (別 page の query) を最新化する。
 * プレビュー (何も書かない) では取り直さない。
 */
export function useImportCustomerContracts(): InvalidatingMutationResultFor<
  typeof importCustomerContracts
> {
  const queryClient = useQueryClient()
  return useMutation(importCustomerContracts, {
    onSuccess: async (response) => {
      if (!response.applied) return
      await Promise.all(
        [
          createConnectQueryKey({
            schema: listCustomers,
            cardinality: undefined,
          }),
          createConnectQueryKey({
            schema: listCustomerSupplyPoints,
            cardinality: undefined,
          }),
          createConnectQueryKey({
            schema: getCustomerSupplyPointFormOptions,
            cardinality: undefined,
          }),
          createConnectQueryKey({
            schema: listContractors,
            cardinality: undefined,
          }),
          createConnectQueryKey({
            schema: getContractTrend,
            cardinality: undefined,
          }),
        ].map((queryKey) => queryClient.invalidateQueries({ queryKey })),
      )
    },
  })
}
